


export enum RegionsEnum {
	jihocesky = 'jihocesky',
	jihomoravsky = 'jihomoravsky',
	karlovarsky = 'karlovarsky',
	kralovehradecky = 'kralovehradecky',
	liberecky = 'liberecky',
	moravskoslezsky = 'moravskoslezsky',
	olomoucky = 'olomoucky',
	pardubicky = 'pardubicky',
	plzensky = 'plzensky',
	praha = 'praha',
	stredocesky = 'stredocesky',
	ustecky = 'ustecky',
	vysocina = 'vysocina',
	zlinsky = 'zlinsky',
}